import React from 'react';
import { useParams } from 'react-router-dom';
import { putawayFlowSchemas } from '../../flows/putawayFlows';
import FlowRunner from './FlowRunner';

const PutawayFlowPage = () => {
  const { flowKey } = useParams();
  const flow = putawayFlowSchemas[flowKey];

  if (!flow) {
    return (
      <div style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
        <div style={{ background: '#fff', color: '#b71c1c', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', borderRadius: 16, padding: 32, minWidth: 320, maxWidth: 400, textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🚫</div>
          <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Flujo no encontrado</div>
          <div style={{ marginBottom: 24 }}>No se encontró la definición del flujo <b>{flowKey}</b>.<br />Verifica la URL o contacta a soporte.</div>
        </div>
      </div>
    );
  }

  return <FlowRunner flow={flow} />;
};

export default PutawayFlowPage; 